// Gallery Images
import img2 from '../../assets/images/main/mistress-diva-pro-dominatrix-and-femdom-black-boots.webp';
import img3 from '../../assets/images/main/mistress-diva-pro-dominatrix-and-femdom-chaining-you-up.webp';
import img4 from '../../assets/images/main/mistress-diva-pro-dominatrix-and-femdom-in-latex-session-black-and-white-miltary-hat.webp';
import img6 from '../../assets/images/main/mistress-diva-pro-dominatrix-and-femdom-in-latex-session-in-full-dominatrix-outfit.webp';
import img7 from '../../assets/images/main/mistress-diva-pro-dominatrix-and-femdom-in-latex-session-with-hard-whip.webp';
import img8 from '../../assets/images/main/mistress-diva-pro-dominatrix-and-femdom-in-latex-session-with-pink-strap-on.webp';
import img9 from '../../assets/images/main/mistress-diva-pro-dominatrix-and-femdom-in-red-blowing-pin-wheel.webp';
import img10 from '../../assets/images/main/mistress-diva-pro-dominatrix-and-femdom-pressed-against-wall.webp';
import img11 from '../../assets/images/main/mistress-diva-pro-dominatrix-and-femdom-stropon-in-the-mirrow.webp';
import img12 from '../../assets/images/main/mistress-diva-pro-dominatrix-and-femdom-with-dangerous-whip.webp';
import img13 from '../../assets/images/main/misress-diva-pro-dominatrix-and-femdom-angel-album-red-dress.webp';

import img14 from '../../assets/images/main/jcz01166-stand.webp';
import img15 from '../../assets/images/main/chain.jpg';

// Alt gallery images
import imgA from '../../assets/images/main/3-748.webp';
import imgA2 from '../../assets/images/main/legs-and-latex.webp';
import imgB from '../../assets/images/main/about-me-1.webp';
import imgC from '../../assets/images/main/back-army-cap.webp';
import imgD from '../../assets/images/main/cap-army.webp';
import imgE from '../../assets/images/main/crop-heels.webp';
import imgF from '../../assets/images/main/flogger-hold.webp';
import imgG from '../../assets/images/main/glass-cabinet.webp';
import imgH from '../../assets/images/main/hold-flogger.webp';
import imgI from '../../assets/images/main/ironing.webp';
import imgJ from '../../assets/images/main/jcz01166-stand.webp';
import imgK from '../../assets/images/main/jodphurs.webp';
import imgL from '../../assets/images/main/leaning.webp';
import imgM from '../../assets/images/main/office.webp';
import imgN from '../../assets/images/main/mistress-diva-pro-dominatrix-and-femdom-with-sissy-slut.webp';
import imgO from '../../assets/images/main/tie-pull.webp';
import imgP from '../../assets/images/main/look-down-dildo.webp';

// Angel album
import imgAngel1 from '../../assets/images/main/misress-diva-pro-dominatrix-and-femdom-angel-album-in-chair.webp';
import imgAngel2 from '../../assets/images/main/misress-diva-pro-dominatrix-and-femdom-angel-album-in-throne.webp';
import imgAngel3 from '../../assets/images/main/misress-diva-pro-dominatrix-and-femdom-angel-album-red-dress.webp';
import imgAngel4 from '../../assets/images/main/misress-diva-pro-dominatrix-and-femdom-angel-album-red-throne.webp';
import imgAngel5 from '../../assets/images/main/misress-diva-pro-dominatrix-and-femdom-angel-album-servant.webp';
import imgAngel6 from '../../assets/images/main/misress-diva-pro-dominatrix-and-femdom-angel-album-throne-and-wings.webp';
import imgAngel7 from '../../assets/images/main/misress-diva-pro-dominatrix-and-femdom-angel-album-white-sofa.webp';
import imgAngel8 from '../../assets/images/main/misress-diva-pro-dominatrix-and-femdom-angel-album-wings.webp';
import imgAngel9 from '../../assets/images/main/misress-diva-pro-dominatrix-and-femdom-angel-album-with-two-slaves.webp';

// Dungeon gallery (unchanged path)
import GalleryNew1 from '../../assets/images/gallery/mistress-diva-dominatrix-in-dungeon-3.webp';
import GalleryNew2 from '../../assets/images/gallery/mistress-diva-dominatrix-in-dungeon-2.webp';
import GalleryNew3 from '../../assets/images/gallery/mistress-diva-dominatrix-in-dungeon-1.webp';
import GalleryNew4 from '../../assets/images/gallery/mistress-diva-dominatrix-in-dungeon-4.webp';


export const angelAlbumImagesArray = [
  {
    src: imgAngel1,
    alt: 'Angel Album in Chair',
    aria: 'Mistress Diva posed in an angelic chair setup',
  },
  {
    src: imgAngel2,
    alt: 'Angel Album in Throne',
    aria: 'Mistress Diva seated in a regal throne with angelic styling',
  },
  {
    src: imgAngel3,
    alt: 'Angel Album in Red Dress',
    aria: 'Mistress Diva dressed in a red gown with angelic features',
  },
  {
    src: imgAngel4,
    alt: 'Angel Album Red Throne',
    aria: 'Mistress Diva seated on a red throne with angelic wings',
  },
  {
    src: imgAngel5,
    alt: 'Angel Album Servant',
    aria: 'Mistress Diva with a servant, angelic imagery',
  },
  {
    src: imgAngel6,
    alt: 'Angel Album Throne and Wings',
    aria: 'Mistress Diva seated with large wings in a throne',
  },
  {
    src: imgAngel7,
    alt: 'Angel Album White Sofa',
    aria: 'Mistress Diva in a serene pose on a white sofa with angelic elements',
  },
  {
    src: imgAngel8,
    alt: 'Angel Album Wings',
    aria: 'Angel wings displayed by Mistress Diva in an ethereal pose',
  },
  {
    src: imgAngel9,
    alt: 'Angel Album with Two Slaves',
    aria: 'Mistress Diva with two slaves in an angelic themed scene',
  },
];

export const altGalleryImagesArray = [
  {
    src: imgA,
    alt: 'Image 3-748',
    aria: 'Dominatrix related imagery 3-748',
    className: 'col-span-1 row-span-1',
  },
  {
    src: imgC,
    alt: 'Back Army Cap',
    aria: 'Image showing a back view with an army cap',
    className: 'col-span-1 row-span-1',
  },
  {
    src: imgA2,
    alt: 'Image 3-748',
    aria: 'Dominatrix related imagery 3-748',
    className: 'col-span-1 row-span-1',
  },
  {
    src: imgE,
    alt: 'Crop Heels',
    aria: 'Heels with a crop accessory',
    className: 'col-span-1 row-span-1',
  },
  {
    src: imgB,
    alt: 'About Me Portrait',
    aria: 'Portrait image titled ABOUT ME 1',
    className: 'col-span-2 row-span-1',
  },
  {
    src: img15,
    alt: 'About Me Portrait',
    aria: 'Portrait image titled ABOUT ME 1',
    className: 'col-span-2 row-span-1',
  },
  {
    src: GalleryNew3,
    alt: 'Dungeon with swing',
    aria: 'Portrait image titled ABOUT ME 1',
    className: 'col-span-2 row-span-1',
  },
  {
    src: imgD,
    alt: 'Cap Army',
    aria: 'Portrait featuring a military-style army cap',
    className: 'col-span-1 row-span-1',
  },
  {
    src: imgF,
    alt: 'Flogger Hold',
    aria: 'Close-up of a hand holding a flogger',
    className: 'col-span-1 row-span-1',
  },
  {
    src: imgG,
    alt: 'Glass Cabinet',
    aria: 'Glass display cabinet scene',
    className: 'col-span-2 row-span-1',
  },
  {
    src: imgP,
    alt: 'Hold Flogger',
    aria: 'Mistress holding a flogger in dominant stance',
    className: 'col-span-1 row-span-2',
  },
  {
    src: GalleryNew4,
    alt: 'Dungeon with cross',
    aria: 'Portrait image titled ABOUT ME 1',
    className: 'col-span-2 row-span-1',
  },
  {
    src: imgH,
    alt: 'Hold Flogger',
    aria: 'Mistress holding a flogger in dominant stance',
    className: 'col-span-1 row-span-2',
  },
  {
    src: imgI,
    alt: 'Ironing',
    aria: 'Unusual dominatrix-themed ironing imagery',
    className: 'col-span-1 row-span-1',
  },
  {
    src: imgJ,
    alt: 'JCZ01166 Stand',
    aria: 'Mistress in standing pose labeled JCZ01166',
    className: 'col-span-1 row-span-1',
  },
  {
    src: imgK,
    alt: 'Jodphurs',
    aria: 'Classic dominatrix jodphurs look',
    className: 'col-span-2 row-span-1',
  },
  {
    src: imgL,
    alt: 'Leaning Pose',
    aria: 'Mistress in a leaning, suggestive pose',
    className: 'col-span-1 row-span-1',
  },
  {
    src: imgM,
    alt: 'Office',
    aria: 'Dominatrix themed office scene',
    className: 'col-span-1 row-span-1',
  },
  {
    src: imgN,
    alt: 'Slut Image',
    aria: 'Image labeled slut',
    className: 'col-span-1 row-span-1',
  },
  {
    src: imgO,
    alt: 'Tie Pull',
    aria: 'Mistress pulling on a tie',
    className: 'col-span-1 row-span-1',
  },
];

export const mainGalleryImagesArray = [
  {
    src: img13,
    alt: 'Mistress Diva above a submissive',
    aria: 'Dominant pose of Mistress Diva standing above a submissive',
    className: 'col-span-2 row-span-1',
  },
  {
    src: img3,
    alt: 'Mistress Diva chaining you up',
    aria: 'Mistress Diva in the act of chaining up her submissive',
    className: 'col-span-1 row-span-2',
  },
  {
    src: img2,
    alt: 'Mistress Diva in black boots',
    aria: 'Close-up shot of Mistress Diva’s black boots in a dominant stance',
    className: 'col-span-1 row-span-1',
  },
  {
    src: GalleryNew1,
    alt: 'Mistress Diva in dungeon',
    aria: 'THe dungeon with swing',
    className: 'col-span-1 row-span-1',
  },
  {
    src: img4,
    alt: 'Mistress Diva in black and white with military hat',
    aria: 'Image of Mistress Diva in black and white wearing a military hat',
    className: 'col-span-2 row-span-1',
  },
  {
    src: img14,
    alt: 'Mistress Diva with head tilted and ball gag',
    aria: 'Portrait of Mistress Diva tilting her head, ball gag in place',
    className: 'col-span-1 row-span-1',
  },
  {
    src: img6,
    alt: 'Mistress Diva in full dominatrix latex outfit',
    aria: 'Full body shot of Mistress Diva in a latex dominatrix outfit',
    className: 'col-span-1 row-span-1',
  },
  {
    src: img7,
    alt: 'Mistress Diva with a hard whip',
    aria: 'Mistress Diva holding a hard whip in a powerful pose',
    className: 'col-span-2 row-span-2',
  },
  {
    src: img11,
    alt: 'Mistress Diva in the mirror with strap-on',
    aria: 'Mistress Diva gazing into the mirror while wearing a strap-on',
    className: 'col-span-1 row-span-2',
  },
  {
    src: img9,
    alt: 'Mistress Diva in red blowing a pinwheel',
    aria: 'Sensual shot of Mistress Diva in red blowing a pinwheel',
    className: 'col-span-1 row-span-1',
  },
  {
    src: img10,
    alt: 'Mistress Diva pressed against wall',
    aria: 'Steamy image of Mistress Diva pressed against the wall',
    className: 'col-span-2 row-span-1',
  },
  {
    src: GalleryNew2,
    alt: 'Mistress Diva in dungeon with cross',
    aria: 'THe dungeon with swing with cross',
    className: 'col-span-1 row-span-1',
  },
  {
    src: img8,
    alt: 'Mistress Diva with pink strap-on',
    aria: 'Mistress Diva displaying a pink strap-on',
    className: 'col-span-1 row-span-1',
  },
  {
    src: img12,
    alt: 'Mistress Diva with dangerous whip',
    aria: 'Intense image of Mistress Diva holding a dangerous-looking whip',
    className: 'col-span-1 row-span-1',
  },
];
